module.exports = __webpack_public_path__ + "static/media/home-homes.07dbd855.png";